var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF4D54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5834 18.5833V16.4167C18.5834 15.842 18.8116 15.2909 19.218 14.8846C19.6243 14.4783 20.1754 14.25 20.75 14.25H31.5834C32.158 14.25 32.7091 14.4783 33.1154 14.8846C33.5218 15.2909 33.75 15.842 33.75 16.4167V31.5833C33.75 32.158 33.5218 32.7091 33.1154 33.1154C32.7091 33.5217 32.158 33.75 31.5834 33.75H20.75C20.1754 33.75 19.6243 33.5217 19.218 33.1154C18.8116 32.7091 18.5834 32.158 18.5834 31.5833V29.4167",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 18.583H16.4167C15.22 18.583 14.25 19.5531 14.25 20.7497V27.2497C14.25 28.4463 15.22 29.4163 16.4167 29.4163H22.9167C24.1133 29.4163 25.0833 28.4463 25.0833 27.2497V20.7497C25.0833 19.5531 24.1133 18.583 22.9167 18.583Z",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 20.8369H26.1666",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 27.25H26.1666",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5725 23.7994V21.8115",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5711 25.9922C19.5582 25.9922 19.5455 25.9948 19.5336 25.9997C19.5217 26.0047 19.5109 26.012 19.5018 26.0211C19.4927 26.0303 19.4856 26.0412 19.4807 26.0531C19.4759 26.0651 19.4735 26.0779 19.4736 26.0908C19.4736 26.1103 19.4795 26.1294 19.4903 26.1457C19.5012 26.1619 19.5167 26.1745 19.5348 26.182C19.5528 26.1894 19.5727 26.1913 19.5919 26.1874C19.611 26.1835 19.6286 26.174 19.6423 26.1601C19.6561 26.1462 19.6654 26.1285 19.669 26.1093C19.6727 26.0901 19.6706 26.0703 19.663 26.0523C19.6554 26.0343 19.6426 26.019 19.6262 26.0083C19.6098 25.9976 19.5907 25.992 19.5711 25.9922",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.28e97182f6075a0ea6aa79e497bea6e1.svg";
export { ForwardRef as ReactComponent };